<template>
  <div class="message-box">
    <div class="message-title">
      <svg-icon icon-class="message-success" />
      {{ payConfirming ? '支付结果确认中' : '订单支付成功' }}
    </div>
    <div v-if="isAntom && payConfirming" style="color: #909399; font-size: 14px; margin-bottom: 20px;">
      正在查询支付结果，请稍候...
    </div>
    <div v-if="isAntom && payTimeout" style="color: #909399; font-size: 14px; margin-bottom: 20px;">
      查询超时，支付结果可稍后在“我的订单”中查看
    </div>
    <div class="message-button">
      <router-link :to="{ name: 'home' }">
        <el-button type="primary">返回首页</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    payMethod: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null,
      queryCount: 0,
      payTimeout: false,
    }
  },
  computed: {
    ...mapState('payResult', ['result']),
    isAntom() {
      return this.payMethod === 'antom-ckp'
    },
    // 确认中：仅 antom 且尚未查到支付成功
    payConfirming() {
      return this.isAntom && this.result !== true
    }
  },
  watch: {
    result(newValue) {
      if (newValue === true) {
        this.stopQuery()
      }
    }
  },
  methods: {
    // 轮询后端查询接口（inquiryPayment），以服务端查询结果为准，不信任回跳本身
    queryResult() {
      this.queryCount++
      if (this.queryCount > 10) {
        this.stopQuery()
        this.payTimeout = true
        return
      }
      this.$store.dispatch('payResult/query', this.id)
    },
    stopQuery() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  mounted() {
    if (this.isAntom) {
      this.timer = window.setInterval(() => {
        this.queryResult()
      }, 3000)
      this.queryResult()
    }
  },
  beforeDestroy() {
    this.stopQuery()
  }
}
</script>
